import type { ReactNode } from 'react';
import { Brand, cn } from '@/core/ui';

interface Props {
  /** Id do curso — mantido na assinatura para uma capa por curso no futuro. */
  seed: string;
  title: string;
  tag?: string;
  className?: string;
  /** Sobreposições: selo de status, duração. */
  children?: ReactNode;
}

/**
 * Capa 16:9 enquanto o catálogo não serve imagem. No backoffice é neutra:
 * fundo azul bem claro, marca e título em azul-petróleo, uma faixa lateral
 * discreta — sem competir com os dados da tela.
 */
export function CourseArt({ title, tag, className, children }: Props) {
  return (
    <div
      className={cn(
        '@container relative aspect-video overflow-hidden rounded-lg bg-surface-2 text-header ring-1 ring-line-strong',
        className,
      )}
    >
      <div
        aria-hidden
        className="absolute inset-y-0 right-0 w-[18%] bg-line-strong"
        style={{ clipPath: 'polygon(35% 0, 100% 0, 100% 100%, 0 100%)' }}
      />
      <div className="absolute inset-0 flex flex-col p-[6%]">
        <Brand size="sm" className="text-header" />
        <p className="mt-auto line-clamp-3 max-w-[75%] text-[0.7rem] leading-snug font-semibold @[14rem]:text-sm">
          {title}
        </p>
        {tag && (
          <span className="mt-1.5 w-fit rounded-sm bg-white px-1.5 py-0.5 text-[0.6rem] font-medium">
            {tag}
          </span>
        )}
      </div>
      {children}
    </div>
  );
}
